import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';
import { findDOMNode } from 'react-dom';
import { mergeStyles } from '@cian/utils';

var InputMask = require('react-input-mask');

import clearSvg from './ic-clear.svg';
import * as styles from './styles.css';
export var VisualSize;

(function (VisualSize) {
  VisualSize[VisualSize["SMALL"] = 0] = "SMALL";
  VisualSize[VisualSize["MEDIUM"] = 1] = "MEDIUM";
  VisualSize[VisualSize["LARGE"] = 2] = "LARGE";
  VisualSize[VisualSize["MOBILE_MEDIUM"] = 3] = "MOBILE_MEDIUM";
})(VisualSize || (VisualSize = {}));

export var TextField = /*#__PURE__*/function (_React$Component) {
  _inherits(TextField, _React$Component);

  var _super = _createSuper(TextField);

  function TextField() {
    var _this;

    _classCallCheck(this, TextField);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "onChange", function (event) {
      _this.props.onValueChange(event.currentTarget.value);
    });

    return _this;
  }

  _createClass(TextField, [{
    key: "focus",
    value: function focus() {
      this.input.focus();
    }
  }, {
    key: "blur",
    value: function blur() {
      this.input.blur();
    }
  }, {
    key: "setSelectionRange",
    value: function setSelectionRange(selectionStart, selectionEnd) {
      this.input.setSelectionRange(selectionStart, selectionEnd);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          size = _this$props.size,
          required = _this$props.required,
          invalid = _this$props.invalid,
          important = _this$props.important;
      var sharedProps = {
        type: this.props.type,
        placeholder: this.props.placeholder,
        id: this.props.id,
        name: this.props.name,
        autoFocus: this.props.autoFocus,
        autoComplete: 'off',
        autoCorrect: this.props.autoCorrect,
        max: this.props.maxValue,
        min: this.props.minValue,
        step: this.props.step,
        maxLength: this.props.maxLength,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        inputMode: this.props.inputMode,
        pattern: this.props.pattern,
        disabled: this.props.disabled,
        value: this.props.value,
        onChange: this.onChange,
        onFocus: this.props.onFocus,
        onBlur: this.props.onBlur,
        onKeyDown: this.props.onKeyDown,
        onPaste: this.props.onPaste
      };
      var sharedStyles = mergeStyles(styles['input'], invalid && styles['invalid'], important && styles['important'], size === VisualSize.SMALL && styles['small'], size === VisualSize.MEDIUM && styles['medium'], size === VisualSize.LARGE && styles['large'], this.props.inputStyle);
      var renderedInput = this.props.mask ? /*#__PURE__*/React.createElement(InputMask, _extends({
        mask: this.props.mask,
        maskChar: this.props.maskChar
      }, this.props.formatChars ? {
        formatChars: this.props.formatChars
      } : {}, {
        alwaysShowMask: this.props.alwaysShowMask
      }, sharedProps, sharedStyles)) : /*#__PURE__*/React.createElement("input", _extends({}, sharedProps, sharedStyles));
      return /*#__PURE__*/React.createElement("span", mergeStyles(styles['container'], required && styles['required'], this.props.containerStyle), renderedInput, this.renderClearButton(size));
    }
  }, {
    key: "renderClearButton",
    value: function renderClearButton(size) {
      if (this.props.value && this.props.onClear) {
        return /*#__PURE__*/React.createElement("button", _extends({}, mergeStyles(styles['clear'], size === VisualSize.SMALL && styles['clear-small'], size === VisualSize.MEDIUM && styles['clear-medium'], size === VisualSize.LARGE && styles['clear-large']), {
          style: {
            backgroundImage: "url('".concat(clearSvg, "')")
          },
          type: "button",
          onClick: this.props.onClear
        }));
      }

      return null;
    }
  }, {
    key: "input",
    get: function get() {
      // eslint-disable-next-line react/no-find-dom-node
      return findDOMNode(this).querySelector('input');
    }
  }, {
    key: "selectionStart",
    get: function get() {
      try {
        return this.input.selectionStart;
      } catch (ex) {
        return undefined;
      }
    }
  }, {
    key: "selectionEnd",
    get: function get() {
      try {
        return this.input.selectionEnd;
      } catch (ex) {
        return undefined;
      }
    }
  }]);

  return TextField;
}(React.Component);

_defineProperty(TextField, "defaultProps", {
  type: 'text',
  size: VisualSize.SMALL
});